// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"77":"fad4c2fc","1934":"34a85ef8"}[chunkId] + ".chunk.css";
};